import FooterContainer from './footer_container';

const Footer = FooterContainer;
export default Footer;
